import React from 'react';
import clsx from 'clsx';
import { Box } from '@mui/material';

import { Icon as IconifyIcon } from '@iconify/react';

interface IconProps {
	/** Specifies the className of the Icon */
	className?: string;
	/** Specifies the classes associated to this object */
	classes?: {
		wrapper?: string;
		icon?: string;
	};
	/** Specifies the icon name. Required, otherwise log a warn in console. */
	icon: string;
	/** Specifies the icon pack to choose from without the ':' (e.g. "fa" for Font Awesome 4, "mdi" for Material Design Icons, etc.). Default to 'mdi' */
	pack?: string;
	/** Specifies the icon size (width=height). Default to 24px */
	size?: number;
	/** Specifies the color of the icon. 'inherit' by default. */
	color?: string;
	/** Specifies the function to execute when the icon is clicked. Undefined by default. */
	onClick?: React.MouseEventHandler<SVGSVGElement>;
}

/**
 * Custom wrapper for package '@iconify/react'
 * (https://github.com/iconify/iconify/tree/master/packages/react)
 *
 * To see all available icons go to https://iconify.design/icon-sets/
 * (there are lots of icons to choose to)
 *
 */
const Icon = React.forwardRef<HTMLSpanElement, IconProps>(
	({ className, classes, icon, pack = 'mdi', size = 24, color = 'inherit', onClick, ...otherProps }, ref) => {
		return (
			<Box ref={ref} className={classes?.wrapper} component="span" color={color} {...otherProps}>
				<IconifyIcon
					className={clsx(className, classes?.icon)}
					icon={`@wise:${pack}:${icon}`}
					width={size}
					height={size}
					color="inherit"
					onClick={onClick}
				/>
			</Box>
		);
	}
);

export default Icon;
